import { get } from 'lodash'

export const selectCreditsByCurrency = (credits, currency) =>
  get(credits, currency) || 0

export const selectIsLoadingUser = state => state.user.isLoading

export const selectCardById = (state, cardId) =>
  state.user?.me?.cards?.find(card => card.id === cardId)
